import React, { useEffect, useRef, useState } from "react";
import { FaqType } from "../../Models/Auth";
import { Box, Divider } from "@mui/material";
import "./CAccordion.scss";

interface AccordionItemProps {
  title: string;
  content: React.ReactNode;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
      } else {
        contentRef.current.style.maxHeight = "0px";
      }
    }
  }, [isOpen]);
  return (
    <div className="accordion-item pb-[24px]">
      <div
        className="flex flex-row justify-between w-full cursor-pointer	"
        onClick={toggleOpen}
      >
        <div className="text-[15px] ml:text-[20px] font-semibold">{title}</div>

        <Box
          component="img"
          className={`arrow-button close ${isOpen ? "open" : "close"} `}
          sx={{
            width: "24px",
            height: "24px",
            "@media (min-width: 768.5px)": {
              width: "32px",
              height: "32px",
            },
          }}
          alt="colendi"
          src={"/icons/faq-arrow-down.svg"}
        />
      </div>
      <div className="accordion-content" ref={contentRef}>
        <div className="pt-[24px] text-[14px] ml:text-[18px] font-normal ">
          {content}
        </div>
      </div>
      <Divider
        className="pt-[24px]"
        sx={{ borderColor: "rgba(0, 0, 0, 0.12)" }}
      />
    </div>
  );
};

interface AccordionProps {
  items: FaqType[];
}

const CAccordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <div id="CAccordion">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.question}
          content={item.answer}
        />
      ))}
    </div>
  );
};

export default CAccordion;
